import { useEffect } from 'react';
import { isLocalhost } from '../utils/domain';
/**
 * Intercepts next data href and prepend the zone path to it.
 * It is a must to use for the unified domain and to keep the SPA behavior
 *
 * @param {{ router: Router }} { router }
 */
export const useNextDataHrefInterceptor = ({ router }) => {
    useEffect(() => {
        var _a;
        if (((_a = router.pageLoader) === null || _a === void 0 ? void 0 : _a.getDataHref) && !isLocalhost()) {
            const originalGetDataHref = router.pageLoader.getDataHref;
            router.pageLoader.getDataHref = function (...args) {
                const r = originalGetDataHref.call(router.pageLoader, ...args);
                return r && r.startsWith('/_next/data') ? `${zonePathGlobal}${r}` : r;
            };
        }
    }, [router]);
};
//# sourceMappingURL=useNextDataHrefInterceptor.js.map